var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 30,
    fill: "#2D9E42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 24H29.4438L26.8313 14.1103C26.8313 14.1103 28.4529 14.1103 28.7011 14.1103C29.0734 14.146 30.5074 13.5765 30.5029 12.1541C30.4983 10.8643 29.3264 10.8912 28.9136 10.8732C28.3313 10.8732 26.5839 10.8732 26.5839 10.8732L21.5341 24H14.0492L9 10.126H15.1789L17.6154 17.49L20.5106 6H31.5798C34.5732 6 37 8.57247 37 11.7447C37 13.8987 35.8811 15.7761 34.2269 16.7591L37 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr);
export default __webpack_public_path__ + "static/media/vr.571a611683fdc85df61af84b46a763f2.svg";
export { ForwardRef as ReactComponent };